import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import PurchaseHistory from '../../components/PurchaseHistory/PurchaseHistory'

const MyPurchaseHistory = () => {
  return (
    <main>
      <Navbar showSeasonDropdown={true} />
      <PurchaseHistory />
    </main>
  )
}

export default MyPurchaseHistory